export const FETCH_EVENTS_REQUEST = 'gustav/analytics/events/FETCH_REQUEST';
export const FETCH_EVENTS_SUCCESS = 'gustav/analytics/events/FETCH_SUCCESS';
export const FETCH_EVENTS_ERROR = 'gustav/analytics/events/FETCH_ERROR';

export const FETCH_COUNTERS_REQUEST = 'gustav/analytics/counters/FETCH_REQUEST';
export const FETCH_COUNTERS_SUCCESS = 'gustav/analytics/counters/FETCH_SUCCESS';
export const FETCH_COUNTERS_ERROR = 'gustav/analytics/counters/FETCH_ERROR';
